:host {
  transition: opacity ease 0.4s;
  opacity: 0;
  display: block;
}
